import { useSelector } from 'react-redux'

import { filterRootSelector } from 'modules/filter/selectors'

const useFilters = () => useSelector(filterRootSelector)

export default useFilters
